import { render, staticRenderFns } from "./VariableIncomeInvestment.vue?vue&type=template&id=311fcaa8&scoped=true&"
import script from "./VariableIncomeInvestment.vue?vue&type=script&lang=ts&setup=true&"
export * from "./VariableIncomeInvestment.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./VariableIncomeInvestment.vue?vue&type=style&index=0&id=311fcaa8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311fcaa8",
  null
  
)

export default component.exports